(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trade-policy-rule', {
            parent: 'entity',
            url: '/trade-policy-rule?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicyRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rules.html',
                    controller: 'TradePolicyRuleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicyRule');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trade-policy-rule-detail', {
            parent: 'entity',
            url: '/trade-policy-rule/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tradePolicyRule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-detail.html',
                    controller: 'TradePolicyRuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tradePolicyRule');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TradePolicyRule', function($stateParams, TradePolicyRule) {
                    return TradePolicyRule.get({id : $stateParams.id});
                }]
            }
        })
        .state('trade-policy-rule.new', {
            parent: 'trade-policy-rule',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-dialog.html',
                    controller: 'TradePolicyRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ruleType: null,
                                fromValue: null,
                                toValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule', null, { reload: true });
                }, function() {
                    $state.go('trade-policy-rule');
                });
            }]
        })
        .state('trade-policy-rule.edit', {
            parent: 'trade-policy-rule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-dialog.html',
                    controller: 'TradePolicyRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TradePolicyRule', function(TradePolicyRule) {
                            return TradePolicyRule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trade-policy-rule.delete', {
            parent: 'trade-policy-rule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trade-policy-rule/trade-policy-rule-delete-dialog.html',
                    controller: 'TradePolicyRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TradePolicyRule', function(TradePolicyRule) {
                            return TradePolicyRule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('trade-policy-rule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
